import { render } from "./DocumentsTable.vue?vue&type=template&id=3e5c13ba"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"

import "./DocumentsTable.vue?vue&type=style&index=0&id=3e5c13ba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__